import React, { useState } from 'react';
import { Container, Row, Col, Carousel } from 'react-bootstrap';
import hero1Img from '../../../../assets/images/home/hero1.jpg';
import hero2Img from '../../../../assets/images/home/hero2.jpg';
import hero3Img from '../../../../assets/images/home/hero3.jpg';
import hero4Img from '../../../../assets/images/home/hero4.jpg';
import '../../../../assets/css/user/home/subscreens/herosection/HeroSection.css';

const HeroSection = () => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const heroData = [
    {
      image: hero1Img,
      heading: 'We Make Your',
      highlight: 'Equipment',
      headingEnd: 'Better',
      subtitle: 'Reliable Agricultural Equipment Solutions',
      description: 'We provide trusted agricultural machinery rental and maintenance services to help farmers complete their work on time. Our goal is to ensure high-quality equipment availability for every season.'
    },
    {
      image: hero2Img,
      heading: 'Professional',
      highlight: 'Machinery',
      headingEnd: 'Rental',
      subtitle: 'Expert Maintenance & Repair Services',
      description: 'Rent modern farming machinery at flexible and budget-friendly rates. SmartAgri Rent makes it simple for farmers to access the right equipment without heavy investment.'
    },
    {
      image: hero3Img,
      heading: 'Expert',
      highlight: 'Maintenance',
      headingEnd: 'Services',
      subtitle: 'Smart Farming with Trusted Solutions',
      description: 'Our skilled technicians offer fast and reliable maintenance services to keep your agricultural equipment running smoothly and efficiently, reducing downtime during critical farming periods.'
    },
    {
      image: hero4Img,
      heading: 'Quality',
      highlight: 'Agricultural',
      headingEnd: 'Solutions',
      subtitle: 'Innovation Meets Tradition',
      description: 'Experience the perfect blend of modern technology and time-tested agricultural practices. We offer cutting-edge equipment solutions backed by decades of experience, ensuring optimal performance for your farming operations.'
    }
  ];

  return (
    <section className="enhanced-hero-section">
      <Container fluid className="p-0">
        <Row className="g-0">
          {/* Left Content Section */}
          <Col lg={6} md={12} className="hero-content-section">
            <div className="hero-content-wrapper">
              {/* Background Tractor Wheel Pattern */}
              <div className="background-pattern">
                <svg className="pattern-svg" viewBox="0 0 600 600">
                  {/* Large Tractor Wheel - Top Left */}
                  <circle cx="120" cy="120" r="90" fill="none" stroke="#FDB714" strokeWidth="2" opacity="0.15"/>
                  <circle cx="120" cy="120" r="70" fill="none" stroke="#FDB714" strokeWidth="2" opacity="0.2"/>
                  <circle cx="120" cy="120" r="50" fill="none" stroke="#FDB714" strokeWidth="2" opacity="0.25"/>
                  <circle cx="120" cy="120" r="30" fill="none" stroke="#FDB714" strokeWidth="2" opacity="0.3"/>
                  <line x1="120" y1="30" x2="120" y2="210" stroke="#FDB714" strokeWidth="2" opacity="0.2"/>
                  <line x1="30" y1="120" x2="210" y2="120" stroke="#FDB714" strokeWidth="2" opacity="0.2"/>
                  <line x1="56" y1="56" x2="184" y2="184" stroke="#FDB714" strokeWidth="1.5" opacity="0.15"/>
                  <line x1="184" y1="56" x2="56" y2="184" stroke="#FDB714" strokeWidth="1.5" opacity="0.15"/>
                  
                  {/* Small Wheel - Bottom Right */}
                  <circle cx="480" cy="480" r="60" fill="none" stroke="#FDB714" strokeWidth="2" opacity="0.12"/>
                  <circle cx="480" cy="480" r="45" fill="none" stroke="#FDB714" strokeWidth="1.5" opacity="0.15"/>
                  <circle cx="480" cy="480" r="30" fill="none" stroke="#FDB714" strokeWidth="1.5" opacity="0.18"/>
                  <line x1="480" y1="420" x2="480" y2="540" stroke="#FDB714" strokeWidth="1.5" opacity="0.15"/>
                  <line x1="420" y1="480" x2="540" y2="480" stroke="#FDB714" strokeWidth="1.5" opacity="0.15"/>
                  
                  {/* Decorative Curves */}
                  <path d="M 50,300 Q 150,280 250,300 T 450,300" stroke="#FDB714" strokeWidth="1.5" fill="none" opacity="0.1"/>
                  <path d="M 100,400 Q 200,380 300,400 T 500,400" stroke="#FDB714" strokeWidth="1.5" fill="none" opacity="0.08"/>
                </svg>
              </div>

              {/* Dynamic Content */}
              <div className="hero-hero-content" key={index}>
                <h1 className="hero-heading animate-text">
                  {heroData[index].heading}<br />
                  <span className="highlight-text">{heroData[index].highlight}</span> {heroData[index].headingEnd}
                </h1>
                
                <div className="subtitle-box animate-subtitle">
                  <p className="hero-subtitle">{heroData[index].subtitle}</p>
                </div>

                <p className="hero-hero-description animate-description">
                  {heroData[index].description}
                </p>
              </div>
            </div>
          </Col>

          {/* Right Image Section with Half Border */}
          <Col lg={6} md={12} className="image-section">
            <div className="image-container">
              <div className="half-border-wrapper">
                {/* Carousel */}
                <Carousel 
                  activeIndex={index} 
                  onSelect={handleSelect}
                  indicators={true}
                  controls={false}
                  interval={3000}
                  fade
                >
                  {heroData.map((item, idx) => (
                    <Carousel.Item key={idx}>
                      <img
                        className="d-block w-100 carousel-image"
                        src={item.image}
                        alt={`Equipment ${idx + 1}`}
                      />
                    </Carousel.Item>
                  ))}
                </Carousel>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;
